import styled, { css } from 'styled-components'

import { _S_Normal, mainColors } from '../../styles'

interface TrackProps {
  active?: boolean
  left?: string
  right?: string
  width?: string
}

const SLIDER_SIZE = 16
const SLIDER_TRACK_HEIGHT = 4

export const Root = styled.div<{ $disabled?: boolean }>`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding-bottom: 20px;
  ${({ $disabled }) =>
    $disabled &&
    css`
      pointer-events: none;
      opacity: 0.5;
      filter: grayscale(50%);
    `};
`

export const SliderContainer = styled.div`
  position: relative;
  height: 16px;
  display: relative;
`

export const Track = styled.div<TrackProps>`
  position: absolute;
  height: ${SLIDER_TRACK_HEIGHT}px;
  border-radius: 50px;
  top: 50%;
  transform: translateY(-50%);
  background-color: ${({ active }) =>
    active ? mainColors.accentMedium : mainColors.neutralMedium};
  left: ${({ left }) => left || '0'};
  right: ${({ right }) => right || '0'};
  width: ${({ width }) => width || 'auto'};
`

export const ThumbsWrapper = styled.div`
  margin: 0 ${SLIDER_SIZE / 2}px;
  position: relative;
`

export const Thumb = styled.div<{ position: string }>`
  position: absolute;
  top: 0;
  left: ${({ position }) => `calc(${position})` || '8px'};
  background-color: ${mainColors.accentMedium};
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  border-radius: 50%;
  width: ${SLIDER_SIZE}px;
  height: ${SLIDER_SIZE}px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: -${SLIDER_SIZE / 2}px;
`

export const ThumbValue = styled.div`
  display: flex;
  position: absolute;
  top: 20px;
  ${_S_Normal};
  color: ${mainColors.neutralExtraDark};
`

export const StyledRangeInput = styled.input.attrs({ type: 'range' })`
  width: 100%;
  outline: none;
  position: absolute;
  top: 0;
  left: 0;
  margin: auto;
  height: ${SLIDER_SIZE}px;
  background-color: transparent;
  pointer-events: none;
  opacity: 0;

  &::-webkit-slider-thumb {
    -webkit-appearance: none;
    height: ${SLIDER_SIZE}px;
    width: ${SLIDER_SIZE}px;
    background-color: transparent;
    cursor: pointer;
    pointer-events: auto;
  }

  &::-moz-range-thumb {
    border: none;
    outline: none;
    -webkit-appearance: none;
    height: ${SLIDER_SIZE}px;
    width: ${SLIDER_SIZE}px;
    cursor: pointer;
    background-color: transparent;
    pointer-events: auto;
  }
`
